<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-head">
            <h1>{{ title }}</h1>
          </div>
          <div class="modal-con">
            <div class="modal-txt">
              <p v-html="contents"></p>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn" @click="close">
                {{ callBackText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { toRefs } from 'vue';

const props = defineProps(['data']);
const { title, contents, callBackText } = toRefs(props.data);
const { fnCallBack } = props.data;
const emits = defineEmits(['close']);

const close = () => {
  if (fnCallBack) fnCallBack();
  setTimeout(() => {
    emits('close');
  }, 500);
};
</script>

<style scoped></style>
